"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const validators_1 = require("./validators");
const reporter_1 = __importDefault(require("../reporter"));
// List of field types that have built-in validation
const FIELD_TYPE_VALIDATION = ['email', 'phone', 'url'];
const runValidations = (item, data) => {
    if (!item.meta || !item.meta.fieldValueAttr) {
        return;
    }
    const validatorEntries = Object.entries(item.meta.validators || {});
    if (FIELD_TYPE_VALIDATION.includes(item.meta.fieldType)) {
        validatorEntries.push([item.meta.fieldType]);
    }
    if (!validatorEntries.length) {
        return;
    }
    const validationErrors = [];
    validatorEntries.forEach(([name, arg]) => {
        // ignore ratingImpact validators
        if (name === 'ratingImpact') {
            return;
        }
        const test = validators_1.validationTests[name];
        if (!test) {
            reporter_1.default.warn(`No validation test for ${name}`);
            return;
        }
        const isValid = test(arg, data)(item[item.meta.fieldValueAttr]);
        if (name === 'requiredForBind') {
            item.meta.required = !isValid;
        }
        else if (!isValid) {
            validationErrors.push(name);
        }
    });
    item.meta.validationErrors = validationErrors;
};
exports.default = runValidations;
//# sourceMappingURL=run-validations.js.map